<!-- Button trigger modal -->
    <!-- Modal -->
    <div class="modal fade" id="editBranchModal" tabindex="-1" role="dialog" aria-labelledby="editBranchModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="editBranchModalLabel">Editar Sucursal</h5>
            <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="editBranchForm" (ngSubmit)="editBranch()">
        <div class="modal-body">
            <div class="form-group">
                <label for="branchName">Sucursal</label>
                <input type="text" class="form-control" id="branchName" formControlName="name">
            </div>
    
            <div class="form-group">
                <label for="addressLine1">Dirección Linea 1</label>
                <input type="text" class="form-control" id="addressLine1" formControlName="address1">
            </div>
    
            <div class="form-group">
                <label for="addressLine2">Dirección Linea 2</label>
                <input type="text" class="form-control" id="addressLine2" formControlName="address2">
            </div>
    
            <div class="form-group">
                <label for="city">Ciudad</label>
                <input type="text" class="form-control" id="city" formControlName="city">
            </div>
    
            <div class="form-group">
                <label for="state">Estado</label>
                <input type="text" class="form-control" id="state" formControlName="state" placeholder="PR" max="2">
            </div>
    
            <div class="form-group">
                <label for="zip">Código Postal</label>
                <input type="text" class="form-control" id="zip" formControlName="zip">
            </div>
    
            <div class="form-group">
                <label for="phone">Teléfono</label>
                <input type="text" class="form-control" id="phone" formControlName="phone">
            </div>
    
            <div class="form-group">
                <label for="email">Email</label>
                <input type="text" class="form-control" id="email" formControlName="email">
            </div>
            <hr>
            <h6>Persona de contacto</h6>
            <div class="form-group">
                <label for="contactPerson">Nombre</label>
                <input type="text" class="form-control" id="contactPerson" formControlName="contact">
            </div>
            <div class="form-group">
                <label for="contactPhone">Teléfono</label>
                <input type="text" class="form-control" id="contactPhone" formControlName="contactPhone">
            </div>
            <div class="form-group">
                <label for="contactEmail">Email</label>
                <input type="text" class="form-control" id="contactEmail" formControlName="contactEmail">
            </div>  
            <div class="form-group">
                <label for="active">Status</label>
                <select class="form-control" id="active" formControlName="active">
                    <option value="true">Activo</option>
                    <option value="false">Inactivo</option>
                </select>
            </div> 
        </div>
        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>
        <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
            Error intente luego...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Añadir</button>
        </div>
        </form>
        </div>
    </div>
    </div>